import { useNavigate } from "react-router-dom";

import { PlusOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";

import { getUser } from "../../../services/auth";
import useDeviceType from "../../../utils/deviceType";
import { FileTable } from "../components/FileTable";

const FileManagement = () => {
  const { Title } = Typography;
  const navigate = useNavigate();
  const { isMobile } = useDeviceType();
  const user = getUser();
  const role = user.role;

  return (
    <div style={{ paddingInline: 20 }}>
      {isMobile ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
            marginBottom: "1rem",
            width: "100%",
          }}
        >
          <Title level={3} style={{ marginBottom: 0, marginTop: "1em" }}>
            File Listing
          </Title>
          {role !== "client" && role !== "agent" && (
            <Button
              type="primary"
              onClick={() => navigate("/files/new")}
              style={{ marginTop: "1em", height: "auto" }}
            >
              <PlusOutlined />
              Create File
            </Button>
          )}
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "nowrap",
          }}
        >
          <Title level={3} style={{ marginBottom: "1em" }}>
            File Listing
          </Title>
          {role !== "client" && role !== "agent" && (
            <Button
              type="primary"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 0,
              }}
              onClick={() => navigate("/files/new")}
            >
              <PlusOutlined />
              Create File
            </Button>
          )}
        </div>
      )}
      <FileTable />
    </div>
  );
};

export default FileManagement;
